/* =========================================================================
   Custom Pages Router — общий скрипт магазина (для theme.liquid)

   Делает две вещи:
     1) Подменяет ссылки на дефолтные страницы товаров -> кастомные страницы.
     2) Авто-редиректит посетителя, если он попал на дефолтную страницу товара.

   Работает в обычном DOM и внутри Shadow DOM (PageFly).

   УСТАНОВКА: положить файл в папку assets темы, затем в <head> файла
   layout/theme.liquid — сразу после {{ content_for_header }} — подключить:
     {{ 'custom-pages-router.js' | asset_url | script_tag }}
   Тег обязан быть в <head> и БЕЗ defer/async, иначе редирект сработает уже
   после отрисовки дефолтной страницы (будет мелькание).
   ========================================================================= */
(() => {
  "use strict";

  /* ======================= НАСТРОЙКА ===================================== */
  /* Чтобы добавить товар — допиши одну строку:                              */
  /*   { product: "<handle-товара>", to: "/pages/<кастомная-страница>" }      */
  /*                                                                         */
  /*   product  — handle товара (то, что идёт в URL после /products/)         */
  /*   path     — точный путь (для не-товарных страниц, напр. главной "/")    */
  /*   to       — путь кастомной страницы                                    */
  /*   redirect — false отключает авто-редирект для правила                   */
  /*              (подмена ссылок при этом продолжает работать)               */
  const ROUTES = [
    { product: "premature-ejaculation-supplements", to: "/pages/ntt-01-pe" },
    { product: "erectile-dysfunction-supplements", to: "/pages/ntt-ed" },
    { product: "testosterone-boosting-supp", to: "/pages/ntt-tb" },
    { product: "the-coach-delay-spray", to: "/pages/ntt-ds" },
    { product: "deodorant-citron-and-sea-salt", to: "/pages/deodorant-citron-and-sea-salt" },
    { product: "dry-shampoo", to: "/pages/dry-shampoo" },
    { product: "hair-and-body-cleansing-bar-citron-and-sea-salt", to: "/pages/hair-and-body-cleaning-bar" },
    { product: "the-coach-bundle-01", to: "/pages/ntt-bundle-him-01" },
    { product: "adam-sensor", to: "/pages/ntt-adam-sensor" },
    { product: "the-coach-for-her-bundle-01", to: "/pages/ntt-her-bundle-01" },
    { product: "vfit-plus-red-light-intimate-wellness-device", to: "/pages/ntt-vfit" },
    { product: "formula-04-vitamins-for-her", to: "/pages/ntt-04-ld" },
    { product: "formula-05-for-her-vaginal-health", to: "/pages/ntt-05-vh" },
    { product: "lips-vulva-balm", to: "/pages/lips-balm" },
    { product: "jasmine-targeted-relaxation-massager", to: "/pages/jasmine-massager" },
    { product: "be-there-in-five-intimate-wash", to: "/pages/ntt-be-there-in-five-intimate-wash" },
    { product: "freshies-intimate-wipes", to: "/pages/freshies-intimate-wipes" },
    { product: "shebar", to: "/pages/ntt-shebar" },
    { product: "reliefher-vaginal-hydration-melts", to: "/pages/ntt-vaginal-hydration-melts" },
    { product: "unlock-your-pleasure", to: "/pages/ntt-bundle-two-01" },
    { product: "viola-finger-massager", to: "/pages/viola-massager" },
    { product: "melt-massage-candle", to: "/pages/melt-massage-candle" },
    { product: "melt-massage-oil", to: "/pages/melt-massage-oil" },
    { product: "signature-bottle-silicone-lube", to: "/pages/signature-lube" },
    { product: "elemi-bullet-massager", to: "/pages/elemi-massager" },
    { product: "kanuka-sensory-restraints", to: "/pages/kanuka-sensory" },
    { product: "coconut-love-oil", to: "/pages/coconut-love-oil" },
    { product: "shag-juice-water-based-lube", to: "/pages/shag-juice" },
    { product: "mini-let-s-spin-intimacy-gel", to: "/pages/ntt-mini-lets-spin-intimacy-gel" },
    { product: "the-coach-bundle-06", to: "/pages/ntt-bundle-him-06" },
    { product: "the-big-night-bundle", to: "/pages/ntt-the-big-night-bundle" },
    { product: "everyday-vulva-moisturizer-with-organic-botanicals", to: "/pages/everyday-vulva-moisturizer" },
    { product: "awaken-arousal-oil-with-organic-botanicals", to: "/pages/awaken-arousal-oil" },
    { product: "massage-oil-with-organic-botanicals", to: "/pages/massage-oil-with-organic-botanicals" },
    { product: "the-coach-glide", to: "/pages/the-coach-glide" },
    { product: "the-intimacy-reset-bundle", to: "/pages/the-intimacy-reset-bundle" },
    { product: "the-intimacy-upgrade-bundle", to: "/pages/the-intimacy-upgrade-bundle" },
    { product: "the-date-night-edit-bundle", to: "/pages/the-date-night-edit-bundle" },
  ];
  /* ======================================================================= */

  const norm = (p) => p.replace(/\/+$/, "") || "/";
  const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // Компилируем правила: матчер по pathname -> { to, redirect }.
  const rules = ROUTES.map((r) => {
    const redirect = r.redirect !== false;
    let match;
    if (r.product) {
      // /products/<handle> как ЦЕЛЫЙ сегмент пути. Ловит и
      // /collections/.../products/<handle>, и локализованные /xx/products/...,
      // но не зацепит /products/<handle>-2 и не .js/.json эндпоинты.
      const re = new RegExp("/products/" + escapeRe(r.product) + "(?:/|$)");
      match = (pathname) => re.test(pathname);
    } else {
      const path = norm(r.path);
      match = (pathname) => norm(pathname) === path;
    }
    return { match, to: r.to, redirect };
  });

  const findRule = (pathname) => {
    for (const rule of rules) {
      if (rule.match(pathname)) return rule;
    }
    return null;
  };

  /* ===== 1. АВТО-РЕДИРЕКТ — выполняется сразу, до отрисовки страницы ====== */
  // В редакторе темы (Shopify designMode) редирект пропускаем, чтобы не мешать.
  const inDesignMode = !!(window.Shopify && window.Shopify.designMode);
  if (!inDesignMode) {
    const rule = findRule(location.pathname);
    if (rule && rule.redirect && norm(location.pathname) !== norm(rule.to)) {
      // location.replace — дефолтная страница не попадёт в историю браузера
      // (кнопка «Назад» не вернёт на неё). Сохраняем query и hash, чтобы не
      // терять utm/tracking-параметры при переходе.
      location.replace(rule.to + location.search + location.hash);
      return; // страница сейчас уйдёт — остальное не запускаем
    }
  }

  /* ===== 2. ПОДМЕНА ССЫЛОК ============================================== */
  const SKIP_HREF = /^(?:#|mailto:|tel:|sms:|javascript:)/i;

  const rewriteLinks = (root) => {
    root.querySelectorAll("a[href]").forEach((a) => {
      const raw = a.getAttribute("href");
      if (!raw || SKIP_HREF.test(raw)) return;
      if (a.host && a.host !== location.host) return; // только свой домен
      const rule = findRule(a.pathname); // pathname: и для отн., и для абс. ссылок
      if (rule && raw !== rule.to) a.setAttribute("href", rule.to);
    });
  };

  // document + все Shadow DOM корни (с учётом вложенности).
  const collectRoots = () => {
    const roots = [document];
    for (let i = 0; i < roots.length; i++) {
      roots[i].querySelectorAll("*").forEach((el) => {
        if (el.shadowRoot) roots.push(el.shadowRoot);
      });
    }
    return roots;
  };

  const observed = new WeakSet();

  // Дебаунс: все мутации одного кадра -> один проход.
  let scheduled = false;
  const scheduleScan = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      runPass();
    });
  };

  const attachObserver = (root) => {
    if (observed.has(root)) return;
    observed.add(root);
    const target = root === document ? document.documentElement : root;
    new MutationObserver(scheduleScan).observe(target, {
      childList: true,
      subtree: true,
    });
  };

  const runPass = () => {
    collectRoots().forEach((root) => {
      attachObserver(root); // новые корни (вкл. shadow) берём под наблюдение
      rewriteLinks(root);
    });
  };

  runPass();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runPass, { once: true });
  }
})();